import { FiChevronRight } from "react-icons/fi";
import { SectionTitle } from "components/sectionTitle";
import data from "assets/data/tutorial/dataV2";
import earthThumb from "assets/images/icons/earthBg.svg";
import lockerThumb from "assets/images/icons/locker-dynamic-color.png";
import TutorialStyleWrapper from "./Tutorial.style";
import { useTranslation } from "react-i18next";
import numberImg1 from "assets/images/icons/One.svg";
import numberImg2 from "assets/images/icons/two.svg";
import numberImg3 from "assets/images/icons/three.svg";

const Tutorial = () => {
  const { t } = useTranslation();

  const data = [
    {
      icon: numberImg1,
      title: t("tutorial.title1"),
      text: t("tutorial.description1"),
    },
    {
      icon: numberImg2,
      title: t("tutorial.title2"),
      text: t("tutorial.description2"),
    },
    {
      icon: numberImg3,
      title: t("tutorial.title3"),
      text: t("tutorial.description3"),
    },
  ];

  return (
    <TutorialStyleWrapper id="benefits">
      <div className="container">
        <div className="row">
          <div className="col-md-6 left_content">
            <SectionTitle
              title={t("tutorial.title")}
              subtitle={t("tutorial.subtitle")}
            />
            <p>{t("tutorial.description")}</p>
            {/* <Button href="/kyc-1" sm variant="outline">
              {" "}
              Verify KYC <FiChevronRight />
            </Button> */}
          </div>
          <div className="col-md-6 right_content">
            {data?.map((step, i) => (
              <div key={i} className="participate-item d-flex">
                <div className="number-image">
                  <img src={step.icon} alt="Participate icon" />
                </div>
                <div className="participate-info">
                  <h4 className="mb-10">{step.title}</h4>
                  <p className="description">{step.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <img
        className="img-fluid bg_shape earth_thumb"
        src={earthThumb}
        alt="img"
      ></img>
      <img
        className="img-fluid bg_shape locker_thumb"
        src={lockerThumb}
        alt="img"
      ></img>
    </TutorialStyleWrapper>
  );
};

export default Tutorial;
